// extracted by mini-css-extract-plugin
export default {"modal":"CommonModalNew_modal__t0-yv"};